import * as React from 'react';
import { render } from 'react-dom';
import App from './components/App';
import './styles/index.less';
var rootEl = document.getElementById('root');
render(React.createElement(App, null), rootEl);
